import {useTranslation} from 'react-i18next';

import DownloadIcon from '@mui/icons-material/Download';
import {Grid, Typography} from '@mui/material';

import {ContactInformationPdfExport} from './ContactInformationPdfExport';
import {CvIcon, TelephoneIcon, EmailIcon} from '../../../../../../assets/icons';
import {EmpionButton} from '../../../../../../components/EmpionButton/EmpionButton';
import {greenColors} from '../../../../../../layouts/theme/designSystem';
import {getApplicantResumeUrl, MatchData} from '../../../../../../types/shared-recruiting-types';

interface Props {
  companyMatchDetails: MatchData;
  /** When false, hide PDF export (e.g. talent pool profile without a match). Default true. */
  enablePdfExport?: boolean;
}

export const ContactInformation = ({companyMatchDetails, enablePdfExport = true}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'companyApplicants.applicantsCard.cardDetails'});

  const applicant = companyMatchDetails?.applicant;
  const applicantResumeUrl = getApplicantResumeUrl(applicant);

  const linkStyles = {
    color: greenColors[700],
  };

  const handleResumeDownload = () => {
    if (!applicantResumeUrl) {
      return;
    }

    window.open(applicantResumeUrl, '_blank');
  };

  return (
    <Grid container item xs={12} sm={6} direction='column'>
      <Typography variant='h3' mb={1}>
        {t('contact')}
      </Typography>
      <Grid item>
        <Grid container alignItems='center'>
          <TelephoneIcon fill={linkStyles.color} style={{marginRight: '8px'}} />
          <Typography variant='body1'>{applicant?.personalInformation.mobilePhoneNumber}</Typography>
        </Grid>
        <Grid container alignItems='center'>
          <EmailIcon fill={linkStyles.color} style={{marginRight: '8px'}} />
          <Typography variant='body1'>{applicant?.personalInformation.email}</Typography>
        </Grid>
        <EmpionButton
          onClick={handleResumeDownload}
          variant='cta'
          disabled={!applicantResumeUrl}
          startIcon={applicantResumeUrl ? <DownloadIcon /> : <CvIcon fill='white' />}
          sx={{
            mt: 1,
            width: 'fit-content',
            minHeight: '32px',
          }}
        >
          {applicantResumeUrl ? t('viewCV') : <i>{t('noCV')}</i>}
        </EmpionButton>
        {enablePdfExport && <ContactInformationPdfExport companyMatchDetails={companyMatchDetails} />}
      </Grid>
    </Grid>
  );
};
